import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

import Section from '../Section';
import DataList from '../DataList';
import { getGushimVeHelkotContentData, getKtovetContentData, getMigrashimContentData } from '../../server/ServerFunc';
import AppFooter from '../AppFooter';
import AppHeaderGlobal from '../AppHeaderGlobal';

const LocationInfo = ({ isSeparate }) => {
  const [ktovetDetails, setKtovetDetails] = useState({});
  const [locationName, setLocationName] = useState("");
  const [gushimList, setGushimList] = useState([]);
  const [migrashimList, setMigrashimList] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [systemCode, setSystemCode] = useState("");

  const pirtyLocationData = [
    { key: 'address', label: 'רחוב', value: locationName },
    { key: 'mispKoma', label: 'קומה', value: ktovetDetails.mispKoma },
    { key: 'schunaName', label: 'שכונה', value: ktovetDetails.schunaName },
    { key: 'cordinataY', label: 'קואורדינטות מרכז (רוחב)', value: ktovetDetails.cordinataY },
    { key: 'mispBait', label: 'מספר בית', value: ktovetDetails.mispBait },
    { key: 'mispDira', label: 'דירה', value: ktovetDetails.mispDira },
    { key: 'mispBinyan', label: 'בניין', value: ktovetDetails.mispBinyan },
    { key: 'cordinataX', label: 'קואורדינטות מרכז (אורך)', value: ktovetDetails.cordinataX },
    { key: 'mispKnisa', label: 'כניסה', value: ktovetDetails.mispKnisa },
    { key: 'rehovgovelName', label: 'רחוב גובל', value: ktovetDetails.rehovgovelName },
    { key: 'kodRovaAhzaka', label: 'רובע', value: ktovetDetails.kodRovaAhzaka }
  ]

  const helkotTitles = {
		"gush": "גוש",
		"miHelka": "חלקה",
		"tatHelka": "תת חלקה",
		"helkeiShlemut": "ח' בשלמותן",
    "shetahHelka": "שטח חלקה",
    "area": "שטח התא", //??
    "areaPercent": "% מהחלקה",
    "helkaMevutelet": "ח' מבוטלת",
	}

  const migrashimTitles = {
		"tohnit": "תוכנית",
		"statusDesc": "סטטוס",
    "taarihStatus": "תאריך סטטוס",
		"kolTochnit": "כל התכנית",
		"migrASh": "תא שטח",
    "yaudDesc": "יעוד",
    "shetah": "שטח"
	}

  const search = useLocation().search;

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    getKtovetContent(systemCodeURL, tikNumURL);
    getGushimVeHelkotContent(systemCodeURL, tikNumURL);
    getMigrashimContent(systemCodeURL, tikNumURL);
    setIsMobile(window.innerWidth < 768);
    setSystemCode(systemCodeURL);
  }, [])
  
  //server
  const getKtovetContent = async (systemCode ,tikNum) => {
    const ktovetContent = await getKtovetContentData(systemCode, tikNum);
    if(Object.keys(ktovetContent).length > 0) {
      setKtovetDetails(ktovetContent);
      calcLocationName(ktovetContent);
    } else {
      setKtovetDetails({});
    }
  }
  
  const getGushimVeHelkotContent = async (systemCode ,tikNum) => { 
    const gushimVeHelkotContent = await getGushimVeHelkotContentData(systemCode, tikNum);
    if(gushimVeHelkotContent.length > 0) {
      setGushimList(gushimVeHelkotContent);
    } else {
      setGushimList([]);
    }
  }

  const getMigrashimContent = async (systemCode ,tikNum) => { 
    const migrashimContent = await getMigrashimContentData(systemCode, tikNum);
    if(migrashimContent.length > 0) {
      setMigrashimList(migrashimContent);
    } else {
      setMigrashimList([]);
    }
  }

  //functions
  const calcLocationName = (ktovetContent) => {
    let location = "";
    if(ktovetContent.rehovName) {
      location = `${ktovetContent.rehovName} ${ktovetContent.mispBait ? ktovetContent.mispBait : ""}, ${ktovetContent.schunaName}`
    } else if(ktovetContent.teurMakom) {
      location = `${ktovetContent.teurMakom}`
    } else {
      location = `${ktovetContent.schunaName}`
    }
    setLocationName(location);
  }

  

  const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			{/* <div className="value">{value}</div> */}
      {
          field === "kolTochnit" ? 
            ((value === 0 || value === null) ? "-" : "☑")
            :
            value
        }
		</div>
	}

  const HelkotLabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(helkotTitles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

  const MigrashimLabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(migrashimTitles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

  const HelkotTable = () => {
    return (
			<Grid data={gushimList} >
				<GridColumn field="gush" title={helkotTitles.gush} cell={HelkotLabeledCell} />
				<GridColumn field="miHelka" title={helkotTitles.miHelka} cell={HelkotLabeledCell} />
				<GridColumn field="tatHelka" title={helkotTitles.tatHelka} cell={HelkotLabeledCell} />
				<GridColumn field="helkeiShlemut" title={helkotTitles.helkeiShlemut} cell={HelkotLabeledCell} />
				<GridColumn field="shetahHelka" title={helkotTitles.shetahHelka} cell={HelkotLabeledCell} />
				<GridColumn field="area" title={helkotTitles.area} cell={HelkotLabeledCell} />
				<GridColumn field="areaPercent" title={helkotTitles.areaPercent} cell={HelkotLabeledCell} />
				<GridColumn field="helkaMevutelet" title={helkotTitles.helkaMevutelet} cell={HelkotLabeledCell} />
			</Grid>
		)
  }

  const MigrashimTable = () => {
    return (
			<Grid data={migrashimList} >
				<GridColumn field="tohnit" title={migrashimTitles.tohnit} cell={MigrashimLabeledCell} />
				<GridColumn field="statusDesc" title={migrashimTitles.statusDesc} cell={MigrashimLabeledCell} />
				<GridColumn field="taarihStatus" title={migrashimTitles.taarihStatus} cell={MigrashimLabeledCell} />
				<GridColumn field="kolTochnit" title={migrashimTitles.kolTochnit} cell={MigrashimLabeledCell} />
				<GridColumn field="migrASh" title={migrashimTitles.migrASh} cell={MigrashimLabeledCell} />
				<GridColumn field="yaudDesc" title={migrashimTitles.yaudDesc} cell={MigrashimLabeledCell} />
				<GridColumn field="shetah" title={migrashimTitles.shetah} cell={MigrashimLabeledCell} />
			</Grid>
		)
  }

  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      {
        systemCode === "26400046" ?
          <div style={{ margin: `${isMobile ? "-103px 0px 0px 0px" : (!isSeparate ? "-115px 0px 0px 0px" : "")}`, backgroundColor: "white" }} >
            <div className="container my-3 my-lg-5">
              <Section icon={'folder-big'} title={'כתובת'} id={'כתובת'}>
                <DataList
                  style={{ "--label-width": "140px" }}
                  items={pirtyLocationData}
                  columns={3}
                />
              </Section>

              <Section icon={'map-point'} title={'חלקות'} id={'חלקות'}>
                {
                  gushimList.length > 0 ?
                    <HelkotTable />
                    :
                    <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                }
              </Section>

              <Section icon={'layers'} title={'מגרשים'} id={'מגרשים'}>
                {
                  migrashimList.length > 0 ?
                    <MigrashimTable />
                    :
                    <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                }
              </Section>
            </div>
          </div>
          :
          <div className="container my-3 my-lg-5">
            <Section icon={'folder-big'} title={'כתובת'} id={'כתובת'}>
              <DataList
                style={{ "--label-width": "140px" }}
                items={pirtyLocationData}
                columns={3}
              />
            </Section>

            <Section icon={'map-point'} title={'חלקות'} id={'חלקות'}>
              {
                gushimList.length > 0 ?
                  <HelkotTable />
                  :
                  <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
              }
            </Section>

            <Section icon={'layers'} title={'מגרשים'} id={'מגרשים'}>
              {
                migrashimList.length > 0 ?
                  <MigrashimTable />
                  :
                  <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
              }
            </Section>
          </div>
      }
      { isSeparate && <AppFooter /> }
    </>
  )
}

export default LocationInfo